const ZUX = {
    showBasket(scrollToProduct) {
        window.dispatchEvent(new CustomEvent("basket-show",{ 
            detail:  {
                scrollToProduct
            }
        }))
    },

    hideBasket() {
        window.dispatchEvent(new CustomEvent("basket-hide",{ 
            detail:  {}
        }))
    }
}

export default ZUX

